import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Modal } from 'bootstrap';
import { Data2Service } from '../../common/data2.service';

@Component({
	selector: 'app-tags',
	templateUrl: './tags.component.html',
	styleUrls: ['./tags.component.css'],
})
export class TagsComponent {
	newTag: string = null;
	private removeTag: string = null;
	@Input() leadId: number;
	@Input() tags: Array<any>;
	@Input() tagsList: Array<any> = [];
	@Output() added = new EventEmitter();
	@Output() deleted = new EventEmitter();

	constructor(private readonly api: Data2Service) {}

	submit(): void {
		if (!this.newTag) {
			return;
		}
		this.added.emit(this.newTag);
		this.newTag = null;
	}

	removeAsk(item): void {
		this.removeTag = item;
		new Modal(document.getElementById('askTagsModal')).show();
	}

	askNo() {
		new Modal(document.getElementById('askTagsModal')).hide();
	}

	askYes(): void {
		this.askNo();
		if (!this.removeTag) {
			return;
		}
		this.deleted.emit(this.removeTag);
		this.removeTag = null;
	}
}
